export default {
    meta: {
        title: '鱼你在一起-提前设计',
        url: '/fishtogether/storeassess',
        urlName: '鱼你店铺评估'
    }
};
